import { Controller } from '@hotwired/stimulus';
import { application } from 'src';
import './component.scss';
import { hideElement, displayElement } from '@fretadao/f-js-dom';
import { TABLET_WIDTH } from 'src/screen_sizes'

const ACTIVE_BTN_CLASS = 'bt--pink';

application.register(
  'board-information',
  class extends Controller {
    static targets = ['ingoingTab', 'outgoingTab', 'tabButton'];
    static currentDirection = null;

    connect() {
      this.handleTabsDisplay();
      window.addEventListener('resize', this.handleTabsDisplay.bind(this));
    }

    disconnect() {
      window.removeEventListener('resize', this.handleTabsDisplay);
    }

    updateTab(e) {
      let selectedBtn = e.target;
      this.updateButtons(selectedBtn);

      this.currentDirection = selectedBtn.dataset.value;
      this.displayOnlyActiveTab();
    }

    updateButtons(selectedBtn) {
      this.tabButtonTargets.forEach(btn => btn.classList.remove(ACTIVE_BTN_CLASS));
      selectedBtn.classList.add(ACTIVE_BTN_CLASS);
    }

    displayOnlyActiveTab() {
      if (this.currentDirection === 'ingoing') {
        displayElement(this.ingoingTabTarget);
        if (this.hasOutgoingTabTarget) hideElement(this.outgoingTabTarget);
      } else if (this.currentDirection === 'outgoing') {
        displayElement(this.outgoingTabTarget);
        if (this.hasIngoingTabTarget) hideElement(this.ingoingTabTarget);
      }
    }

    handleTabsDisplay() {
      if (window.innerWidth <= TABLET_WIDTH) {
        this.highlightFirstButtonIfNoneAreHighligthed();
        this.displayOnlyActiveTab();
      } else {
        this.displayAllTabs();
      }
    }

    highlightFirstButtonIfNoneAreHighligthed() {
      if (this.tabButtonTargets.every(btn => !btn.classList.contains(ACTIVE_BTN_CLASS))) {
        this.tabButtonTarget.classList.add(ACTIVE_BTN_CLASS);
        this.currentDirection = this.tabButtonTarget.dataset.value;
      }
    }

    displayAllTabs() {
      let tabs = [];
      if (this.hasIngoingTabTarget) tabs.push(this.ingoingTabTarget);
      if (this.hasOutgoingTabTarget) tabs.push(this.outgoingTabTarget);
      tabs.map(tab => displayElement(tab));
    }
  }
);
